export const isValid = (value) => {
    if (typeof value === 'number') {
        return Number.isFinite(value);
    }
    return value != null && value !== '' && value !== false;
};
//# sourceMappingURL=isValid.js.map